/* BFL interactive behaviours, ported from the static site's js/nav.js.
   (The mobile nav part is omitted — Dawn's header handles its own menu.) */

/* Mobile nav toggle (BFL header) */
(function () {
  function init() {
    var toggle = document.querySelector('.nav-toggle');
    var nav = document.getElementById('primary-nav');
    if (!toggle || !nav || toggle.dataset.bflNavInit) return;
    toggle.dataset.bflNavInit = '1';

    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });

    nav.addEventListener('click', function (e) {
      if (e.target.closest('a') && nav.classList.contains('is-open')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
      }
    });
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* Tabbed panels (design styles) */
(function () {
  function init() {
    var groups = document.querySelectorAll('[data-tabs]');
    for (var g = 0; g < groups.length; g++) {
      (function (group) {
        if (group.dataset.bflTabsInit) return;
        group.dataset.bflTabsInit = '1';
        var tabs = group.querySelectorAll('.styles__tab');
        var panels = group.querySelectorAll('.styles__panel');
        for (var i = 0; i < tabs.length; i++) {
          tabs[i].addEventListener('click', function () {
            var key = this.getAttribute('data-panel');
            for (var j = 0; j < tabs.length; j++) {
              var on = tabs[j] === this;
              tabs[j].classList.toggle('is-active', on);
              tabs[j].setAttribute('aria-selected', on ? 'true' : 'false');
            }
            for (var k = 0; k < panels.length; k++) {
              panels[k].classList.toggle('is-active', panels[k].getAttribute('data-panel') === key);
            }
          });
        }
      })(groups[g]);
    }
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init); /* customizer re-renders */
})();

/* Pop-out enquiry modal (book a home visit / order a brochure) */
(function () {
  var modal, dialog, lastFocused;
  var STORE_KEY = 'bflModalPanel';

  function focusableIn(container) {
    if (!container) return [];
    var sel = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.slice.call(container.querySelectorAll(sel)).filter(function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }

  function activePanel() {
    return modal ? modal.querySelector('.bfl-modal__panel:not([hidden])') : null;
  }

  function trapList() {
    var list = focusableIn(activePanel());
    var closeBtn = modal.querySelector('.bfl-modal__close');
    if (closeBtn) list.unshift(closeBtn);
    return list;
  }

  /* Put a panel back to a blank, submittable form. Called every time a panel is
     opened, so a previous submission can never leave a "thank you" where the
     next visitor expects a form. */
  function reset(panel) {
    if (!panel) return;
    var success = panel.querySelector('[data-bfl-success]');
    var error = panel.querySelector('[data-bfl-error]');
    var fields = panel.querySelector('[data-bfl-fields]');
    if (success) { success.hidden = true; }
    if (error) { error.hidden = true; }
    if (fields) { fields.hidden = false; }
  }

  /* preserveState is set when we open a panel to show the result of a post, so
     the reset does not wipe the message we are about to reveal. */
  function open(type, preserveState) {
    modal = document.getElementById('bfl-modal');
    if (!modal) return;
    dialog = modal.querySelector('.bfl-modal__dialog');
    var panels = modal.querySelectorAll('.bfl-modal__panel');
    var titleId = '';
    for (var i = 0; i < panels.length; i++) {
      var on = panels[i].getAttribute('data-modal-panel') === type;
      panels[i].hidden = !on;
      if (on) {
        if (!preserveState) { reset(panels[i]); }
        var h = panels[i].querySelector('.bfl-modal__title');
        if (h) { titleId = h.id; }
      }
    }
    if (titleId && dialog) { dialog.setAttribute('aria-labelledby', titleId); }
    lastFocused = document.activeElement;
    modal.hidden = false;
    modal.classList.add('is-open');
    document.documentElement.classList.add('bfl-modal-open');
    var first = focusableIn(activePanel())[0];
    (first || dialog).focus();
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.documentElement.classList.remove('bfl-modal-open');
    if (lastFocused && lastFocused.focus) { lastFocused.focus(); }
  }

  /* Drop ?contact_posted=true and the form fragment from the address bar once
     we have shown the result, so a reload or a Back does not replay it. */
  function tidyUrl() {
    if (!window.history || !history.replaceState) return;
    var search = location.search
      .replace(/([?&])contact_posted=true(&|$)/, '$1')
      .replace(/[?&]$/, '');
    try { history.replaceState(null, '', location.pathname + search); } catch (e) {}
  }

  /* Show the result of a native contact-form post.

     The forms post normally (see the submit listener below), so Shopify sends
     the visitor back to this page with ?contact_posted=true on success. That
     flag is page-wide: with more than one {% form 'contact' %} on a page Liquid
     cannot tell which one posted, which is why the panels no longer branch on
     it server side. We identify the form here instead: its action carries its
     own id as a fragment (/contact#BflBookForm) and the browser keeps that
     fragment across Shopify's redirect, so location.hash names the exact form.
     The sessionStorage marker is a fallback for the rare case the fragment is
     lost, and is consumed on read so it can never resurface on a later page. */
  function showResult() {
    var pending = null;
    try {
      pending = sessionStorage.getItem(STORE_KEY);
      sessionStorage.removeItem(STORE_KEY);
    } catch (e) {}

    var m = document.getElementById('bfl-modal');
    if (!m) return;

    var type = null;
    var hash = (location.hash || '').replace(/^#/, '');
    if (hash) {
      var forms = m.querySelectorAll('form[data-bfl-form]');
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].id === hash) { type = forms[i].getAttribute('data-bfl-form'); break; }
      }
    }
    if (!type) { type = pending; }
    if (!type) return;

    var panel = m.querySelector('.bfl-modal__panel[data-modal-panel="' + type + '"]');
    if (!panel) return;

    var success = panel.querySelector('[data-bfl-success]');
    var error = panel.querySelector('[data-bfl-error]');
    var fields = panel.querySelector('[data-bfl-fields]');
    var posted = /[?&]contact_posted=true(&|$)/.test(location.search);
    var errorText = error ? error.textContent.trim() : '';

    if (posted) {
      if (fields) { fields.hidden = true; }
      if (error) { error.hidden = true; }
      if (success) { success.hidden = false; }
      open(type, true);
      if (success) { success.setAttribute('tabindex', '-1'); success.focus(); }
      tidyUrl();
    } else if (errorText) {
      if (error) { error.hidden = false; }
      open(type, true);
      error.setAttribute('tabindex', '-1');
      error.focus();
    }
  }

  function onKey(e) {
    if (!modal || !modal.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var list = trapList();
    if (!list.length) { e.preventDefault(); dialog.focus(); return; }
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!modal.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  }

  function bind() {
    if (document.documentElement.dataset.bflModalBound) return;
    document.documentElement.dataset.bflModalBound = '1';

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-bfl-modal]');
      if (trigger) { e.preventDefault(); open(trigger.getAttribute('data-bfl-modal')); return; }
      if (e.target.closest('[data-bfl-modal-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', onKey);

    /* Note there is deliberately no preventDefault here. Shopify's /contact
       endpoint sits behind Cloudflare bot mitigation that answers a fetch or
       XHR post with "cf-mitigated: challenge" and 403, because a challenge can
       only be solved by a real navigation. The forms therefore post natively,
       exactly as Dawn's contact form does, and we record which panel posted so
       showResult() can reveal that panel's own message after the reload. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.closest) return;
      var panel = form.closest('#bfl-modal .bfl-modal__panel');
      if (!panel) return;
      try { sessionStorage.setItem(STORE_KEY, panel.getAttribute('data-modal-panel')); } catch (er) {}
    });

    /* Left over from the first version of this flow. Clear it so a stale value
       can never resurrect a success panel on a later page view. */
    try { sessionStorage.removeItem('bflModalType'); } catch (er) {}

    showResult();

    /* Stamp the page (full URL, query params included) into the panel forms
       client-side, so the lead email and Klaviyo record exactly where the
       pop-up was submitted from - immune to page caching, and campaign links
       like ?ref=xyz are captured verbatim. */
    var stamps = document.querySelectorAll('input[data-bfl-page]');
    for (var s = 0; s < stamps.length; s++) { stamps[s].value = location.href; }

    /* ?popup=book|brochure on any URL opens that panel directly, so links in
       ads/emails can deep-link straight to the form. Skipped on the
       post-submit reload so it never fights the result reveal. */
    var deep = location.search.match(/[?&]popup=(book|brochure)(&|$)/);
    if (deep && !/[?&]contact_posted=true(&|$)/.test(location.search)) { open(deep[1]); }
  }

  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);
})();

/* Reserve page space for Shopify's cookie-consent banner.
   The banner is injected asynchronously, sits position: fixed over the bottom
   of the viewport at z-index 2000000, and reserves no space of its own, so it
   covers the end of the footer until the visitor accepts or declines. We
   publish its live height as --bfl-consent-h and bfl-footer.css reserves that
   much padding under the footer's bottom bar. */
(function () {
  var SEL = '#shopify-pc__banner, .shopify-pc__banner__dialog';

  function measure() {
    var banner = document.querySelector(SEL);
    var h = 0;
    if (banner) {
      var cs = getComputedStyle(banner);
      /* Only reserve space for an overlay. If Shopify ever renders the banner
         in flow, it already takes up its own space. */
      if (cs.position === 'fixed' && cs.display !== 'none' && cs.visibility !== 'hidden') {
        h = Math.ceil(banner.getBoundingClientRect().height);
      }
      if (window.ResizeObserver && !banner.dataset.bflConsentWatched) {
        banner.dataset.bflConsentWatched = '1';
        new ResizeObserver(measure).observe(banner); /* "Manage preferences" resizes it */
      }
    }
    document.documentElement.style.setProperty('--bfl-consent-h', h + 'px');
  }

  function init() {
    if (document.documentElement.dataset.bflConsentInit) return;
    document.documentElement.dataset.bflConsentInit = '1';
    measure();

    /* The banner is added after first paint and removed (or hidden) on
       accept/decline, so watch body's direct children and re-measure after a
       click inside it. */
    if (window.MutationObserver) {
      new MutationObserver(measure).observe(document.body, { childList: true });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest(SEL)) {
        setTimeout(measure, 0);
        setTimeout(measure, 350);
      }
    });
    window.addEventListener('resize', measure);
  }

  document.addEventListener('DOMContentLoaded', init);
})();

/* Before/after image sliders */
(function () {
  function init() {
    var sliders = document.querySelectorAll('.ba');
    for (var i = 0; i < sliders.length; i++) {
      (function (ba) {
        if (ba.dataset.bflBaInit) return;
        ba.dataset.bflBaInit = '1';
        var range = ba.querySelector('.ba__range');
        if (!range) return;
        var update = function () { ba.style.setProperty('--pos', range.value + '%'); };
        range.addEventListener('input', update);
        update();
      })(sliders[i]);
    }
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

/* Klaviyo list push. Any form with data-klaviyo-list="<listId>" gets its
   lead pushed to that Klaviyo list on submit (fetch keepalive so the call
   survives the native /contact navigation). Reads the standard contact[...]
   field names; full name is split into first/last. */
(function () {
  var KLAVIYO_COMPANY_ID = 'XzxkfK';
  function init() {
    var forms = document.querySelectorAll('form[data-klaviyo-list]');
    for (var i = 0; i < forms.length; i++) {
      (function (f) {
        if (f.dataset.bflKlaviyoInit) return;
        f.dataset.bflKlaviyoInit = '1';
        f.addEventListener('submit', function () {
          try {
            // Forms with an explicit marketing opt-in checkbox only push
            // to Klaviyo when it is ticked (the form copy promises that).
            var optIn = f.querySelector('input[type="checkbox"][name="contact[Marketing opt-in]"]');
            if (optIn && !optIn.checked) return;
            var val = function (n) {
              var el = f.querySelector('[name="contact[' + n + ']"]');
              return el ? el.value : '';
            };
            var first = val('First name');
            var last = val('Last name');
            if (!first && val('name')) {
              var parts = val('name').trim().split(/\s+/);
              first = parts.shift() || '';
              last = parts.join(' ');
            }
            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
              method: 'POST',
              keepalive: true,
              headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    profile: { data: { type: 'profile', attributes: {
                      email: val('email'),
                      first_name: first,
                      last_name: last,
                      properties: {
                        Phone: val('phone'),
                        Postcode: val('Postcode'),
                        'Postal address': val('Postal address'),
                        'Preferred contact time': val('Preferred contact time'),
                        Source: val('Enquiry source'),
                        Page: val('Page')
                      }
                    } } }
                  },
                  relationships: { list: { data: { type: 'list', id: f.dataset.klaviyoList } } }
                }
              })
            });
          } catch (e) {}
        });
      })(forms[i]);
    }
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
